/* import __COLOCATED_TEMPLATE__ from './shared-by.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();